import { HorizontalContainer } from '@american-autonomy/ag-ui';

import QuickActionChip from 'components/airspace/QuickActionChip';
import {
    CURRENT_LOCATION_LABEL,
    SAVED_PLACES_LABEL
} from 'components/airspace/SearchDrawer/constants';
import { LocationIcon, SavedPlacesIcon } from 'components/airspace/SearchDrawer/icons';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const QuickActionsRow: FunctionComponent<Props> = ({
    className = '',
    isLoadingCurrentLocation,
    onCurrentLocation,
    onSavedPlaces,
    parentTestId,
    testId = TEST_ID
}) => (
    <HorizontalContainer className={`${styles.quickActionsRow} ${className}`} testId={testId}>
        <QuickActionChip
            icon={<LocationIcon />}
            isLoading={isLoadingCurrentLocation}
            label={CURRENT_LOCATION_LABEL}
            onClick={onCurrentLocation}
            testId={`${parentTestId}-currentLocationChip`}
        />

        <QuickActionChip
            icon={<SavedPlacesIcon />}
            label={SAVED_PLACES_LABEL}
            onClick={onSavedPlaces}
            testId={`${parentTestId}-savedPlacesChip`}
        />
    </HorizontalContainer>
);

export default QuickActionsRow;
